import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const XSmallFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function XSmallFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m17.06 9.06-2.12-2.12L12 9.88 9.06 6.94 6.94 9.06 9.88 12l-2.94 2.94 2.12 2.12L12 14.12l2.94 2.94 2.12-2.12L14.12 12l2.94-2.94Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default XSmallFilled;